'use strict';

function DetailedList() {
	return {
		restrict: 'E',
		scope: { list: '=' },
		replace: true,
		templateUrl: 'views/components/detailedList.html'
	};
}

export default DetailedList


// WEBPACK FOOTER //
// ./src/app/scripts/directives/detailedListDirective.js